<template>
<component :is='c_name' :md3="md==3" :md4="md==4" :md6="md==6" :md8="md==8">
  <h3>{{label}}</h3>
  <slot></slot>
  <Doughnut2 :id="id"
    v-if="value"
    :legendDisplay="false"
    :data.sync="data"
    :data_ex.sync="data_ex"
    :gauge.sync="status_value"
    :colors="colors"
    />
    <div class="total">{{cl1}} - {{cl2}}</div>
  <div class="d_info">
		<div>
			<div v-for="(v,i) in sgp" :key="i">{{v.label}}</div>
		</div>
		<div>
			<div v-for="(v,i) in sgp" :key="i">{{v.value}}</div>
		</div>
	</div>
</component>
</template>

<script>
import Doughnut2 from "@/components/graphs/Doughnut2.vue";
import {v4 as uuid} from 'uuid';
export default {
	components:{Doughnut2},
  props:['label','value','md','click','class_name','div','class_container','l1'],
  data() {
    return {
      id: uuid(),
      colors:['#CC0031','#DF781E','#E8D243','#7CD054'],
      data:[25,25,25,25],
      cl2:'100%'
    }
  },
  computed:{
    cl1(){
      const total = ((this.value||{count:{total:0}}).count.total);
      return `Total ${total}`
    },
    c_name(){ return this.div? 'div':'v-flex'},
		sgp() {
      const {count} = this.value || {count:{total:0,expired:0,current:0,'1mm':0,'3mm':0}};
      return [
				{label:'Caducado',value:count.expired},
				{label:'1 mes por vencer',value:count['1mm']},
				{label:'3 meses por vencer',value:count['3mm']},
				{label:'Vigente',value:count.current},
			]
    },
    status_value() {
      const {status_value} = this.value || {status_value:0};
      return status_value
    },
    data_ex(){
      const de = [];
      if(this.l1) this.sgp.forEach(e => {
        const value = (e.value||0);
        const total = ((this.value||{count:{total:0}}).count.total);
        de.push({
          l1:this.l1?this.l1(value):value/* `${value} EA` */,
          l2:`${parseFloat((value/total)*100).toFixed(1)}%`
        })  
      });
      return de;
    }
  },
};
</script>

<style scoped>
.total{
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  margin-top: -10px;
}
.barra_sgp>div:nth-of-type(2){margin: auto;}
.barra_sgp>div:nth-of-type(2)>div:nth-of-type(1){
	height: 30px;
	width: 100%;
}
.d_info>div>div{
	display: inline-block;
	width: 25%;
	height: 100%;
	text-align: center;
  padding: 5px 5px 0 5px;
  vertical-align: middle;
  font-weight: bolder;
}
.d_info>div:nth-of-type(2){
	font-size: 25px;
	color: coral;
}
.barra_sgp>div:nth-of-type(2)>div:nth-of-type(2),
.barra_sgp>div:nth-of-type(2)>div:nth-of-type(3){
	padding: 5px;
	font-weight: bold;
}
.barra_sgp>div:nth-of-type(2)>div:nth-of-type(2){font-size: 15px;}
</style>
